import React from 'react';
import { Row } from '../Table';
import { entries } from 'common_util_node/util';
import styled from 'styled-components';
import { colors } from '../../../styles/colors';

type Props = {
  row: Row;
  onRowClick: (row: Row) => void;
  className?: string;
};

export class TableRow extends React.PureComponent<Props> {
  render() {
    const { row, onRowClick } = this.props;
    return <ClickableRow className={`TableRow ${this.props.className || ''}`} onClick={() => onRowClick(row)}>
      {
        entries(row).map(([key, value]) => <Cell key={key} className={`cell ${key}`}>{value}</Cell>)
      }
    </ClickableRow>;
  }
}

const ClickableRow = styled.tr`
  cursor: pointer;
  transition: background-color 0.25s cubic-bezier(0.22, 0.61, 0.36, 1);;

  :hover {
    background: ${colors.backgroundLight};
  }
`;

const Cell = styled.td`
  color: ${colors.text};
  padding: 0.5em 0;
  word-break: break-all;
`;
